<template>
  <div>
    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-filter" class="w-full"
      @click="isOpen = true">
      {{ $t('filters') | capitalize }}
    </vs-button>

    <base-modal :isOpen="isOpen" :title="$t('filters') | capitalize" @close="isOpen = false">

      <!-- Body -->
      <template #body>
        <vs-row class="mb-2">
          <vs-col class="px-2">
            <v-select class="w-full" label="client_name" :placeholder="$t('client')" v-model="client"
              :reduce="(item) => item.client_id" :options="clientList" clearable>
            </v-select>
          </vs-col>
        </vs-row>

        <vs-row class="mb-2">
          <vs-col class="px-2">
             <v-select class="w-full" label="wk" :placeholder="$t('week')" v-model="week" multiple
              :reduce="(item) => item.wk" :options="weekList" clearable>
            </v-select>
          </vs-col>
        </vs-row>
      </template>

      <!-- Footer -->
      <template #footer>
        <vs-button color="danger" type="border" @click="isOpen = false">
          {{ $t('cancel') | capitalize }}
        </vs-button>
        <vs-button color="danger" @click="handleSubmit">
          {{ $t('apply') | capitalize }}
        </vs-button>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '@/views/app/components/modals/BaseModal.vue';
import vSelect from 'vue-select'

export default {
  name: 'BonusFilter',
  components: { BaseModal, 'v-select': vSelect },
  props: {
    clientList: {
      type: Array,
      default: () => []
    },
    weekList: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({
        client: null,
        week: null
      })
    }
  },
  data() {
    return {
      isOpen: false,
      client:null,
      week:null
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.client = this.filters.client
        this.week = this.filters.week
      }

    }
  },
  methods: {
    // updateFilter(key, value) {
    //   // emitimos el objeto completo actualizado
    //   this.$emit('update:filters', { ...this.filters, [key]: value })
    // },
    handleSubmit() {
      const filters = {
        client: this.client,
        week:this.week
      }
      this.$emit('apply-filters',{ ...filters})
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
::v-deep(.vs__dropdown-menu) {
  max-height: 50px;
  overflow-y: auto;
}
</style>